__turbopack_context__.v({
  "content": "Headlines-module-scss-module__BlLkbG__content",
  "list": "Headlines-module-scss-module__BlLkbG__list",
  "noPublishedArticles": "Headlines-module-scss-module__BlLkbG__noPublishedArticles",
  "section": "Headlines-module-scss-module__BlLkbG__section",
  "sectionRoot": "Headlines-module-scss-module__BlLkbG__sectionRoot",
  "titlePrimary": "Headlines-module-scss-module__BlLkbG__titlePrimary",
  "titleSecondary": "Headlines-module-scss-module__BlLkbG__titleSecondary",
});
